/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export function resetPageAfterDeletion({ totalCount, removed = 1, page, itemsPerPage, setPage }) {
  const currentTotal = Number.parseInt(totalCount, 10) || 0;
  const removedCount = Number.parseInt(removed, 10) || 0;

  const newTotalCount = Math.max(currentTotal - removedCount, 0);
  const totalPages = Math.ceil(newTotalCount / (itemsPerPage || 1));

  if (page > totalPages && totalPages > 0) {
    setPage(page - 1);
  }
}

export default resetPageAfterDeletion;
